module.exports = __webpack_public_path__ + "static/media/IGDTUW1.46862af0.jpeg";